import { createContext } from 'react';

export const DispatchContext = createContext(null);